var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_15)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_301_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8713 8.14936C37.9027 4.18079 32.6241 2 27.0142 2C21.3965 2 16.1256 4.18079 12.1571 8.14936C8.18849 12.1179 6 17.3965 6 23.0065C6 34.3573 16.7344 43.8049 22.5062 48.8754C23.3076 49.5843 23.9934 50.1931 24.5483 50.7017C25.2418 51.349 26.128 51.6727 27.0142 51.6727C27.9004 51.6727 28.7865 51.349 29.4724 50.7017C30.0272 50.1931 30.7207 49.5843 31.5222 48.8754C37.2862 43.8049 48.0206 34.3573 48.0206 23.0065C48.0206 17.3965 45.8398 12.1179 41.8713 8.14936Z",
    fill: "#39335D",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28 12L17 17.0577V34H21.7143V26.9537H34.2857V34H39V17.0577L28 12ZM26.4286 15.9929H29.5714V17.5587H26.4286V15.9929ZM34.2857 25.3879H21.7143V23.8221H34.2857V25.3879ZM34.2857 22.2562H21.7143V21.0114L22.0364 20.6904H33.9636L34.2857 21.0114V22.2562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_301_15",
    x: 0.5,
    y: 0.5,
    width: 53.0205,
    height: 60.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_15"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_15",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWarehouse);
export default __webpack_public_path__ + "static/media/blueWarehouse.88e12eaddabb1896f7dc3e6e98395a40.svg";
export { ForwardRef as ReactComponent };